let activeMediaViewerCloser = null;

export const registerMediaViewer = closer => {
  activeMediaViewerCloser = closer;
};

export const unregisterMediaViewer = closer => {
  if (activeMediaViewerCloser === closer) {
    activeMediaViewerCloser = null;
  }
};

export const closeActiveMediaViewer = () => {
  if (!activeMediaViewerCloser) return false;

  activeMediaViewerCloser();
  return true;
};
